'use strict'

import React from 'react'
import { render } from 'react-dom'

import App from './app.js'

// States that are considered as 'loaded'.
const loaded = [
    'complete',
    'loaded',
    'interactive'
]

// Is the document ready state 'loaded'?
if (loaded.includes(document.readyState) && document.body) {

    // Render app.
    init()
} else {

    // Register an event listener to render the app when the dom is ready.
    window.addEventListener('DOMContentLoaded', init, false)
}

// Render application on dom.
function init() {

    render(<App />, document.querySelector('#StencilDisplaySettingsApp'))
}
